<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // window.onerror = function(msg) {
    //   // 返回 true 则错误消息不显示在控制台，返回 false，则错误消息将会展示在控制台
    //   Toast.fail(msg)
    //   return false
    // }
    // iPhone X、iPhone XS
    const isIPhoneX =
      /iphone/gi.test(window.navigator.userAgent) &&
      window.screen.width === 375 &&
      window.screen.height === 812;
    // iPhone XS Max
    const isIPhoneXSMax =
      /iphone/gi.test(window.navigator.userAgent) &&
      window.screen.width === 414 &&
      window.screen.height === 896;
    // iPhone XR
    const isIPhoneXR =
      /iphone/gi.test(window.navigator.userAgent) &&
      window.screen.width === 414 &&
      window.screen.height === 896;
    if (isIPhoneXR || isIPhoneXSMax || isIPhoneX) {
      this.$root.$data.store.setMessageAction(true);
    }
  },
};
</script>

<style lang="less">
#app{
  background: #F7F8FA;
}
.qr_code {
  width: 100%;
  background: #fff;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  color: #323233;
  padding: 10px;
  img {
    width: 80%;
    margin: 18px auto;
  }
}
.footer {
  position: fixed;
  bottom: 0;
  z-index: 10;
  width: 100%;
  box-shadow: 0px -2px 4px rgba(121, 121, 121, 0.08);
  background: #fff;
  .btn {
    height: 64px;
    padding: 0 32px;
  }
}
img {
  vertical-align: bottom;
  display: block;
}
html,
body {
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
  height: 100%;
  margin: 0;
  background: #f7f8fa;
}
.ft {
  font-family: Arial, Helvetica, sans-serif;
}
#app {
  width: 100%;
  height: 100%;
}
.p3 {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
}
.flex-center {
  display: flex;
  align-items: center;
}
* {
  box-sizing: border-box;
}
.empty_wrap {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  padding-top: 140px;
  color: rgba(166, 166, 166, 0.98);
}
.boxSizing {
  box-sizing: border-box;
}
.flex {
  display: -webkit-flex;
  display: flex;
}
.a_flex_column {
  flex-direction: column;
}
.a_flex_a {
  align-items: center;
}
.a_flex_j {
  justify-content: center;
}
.a_flex_j_sb {
  justify-content: space-between;
}
.a_flex_j_sa {
  justify-content: space-around;
}
.a_position_r {
  position: relative;
}
.a_position_a {
  position: absolute;
}
.a_position_f {
  position: fixed;
}
.a_position_s {
  position: sticky;
  top: 0;
}
.a_bg {
  background: #ffffff;
}
.error-text {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #7d7e80;
  font-size: 14px;
  padding: 64px 0 32px 0;
}
.text_overFlow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
